// src/components/RosterSkeleton.jsx
// Placeholder cards shown while the roster loads, so the grid doesn't flash
// empty before the data arrives.

function RosterSkeleton({ count = 4 }) {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="bg-gray-900 border border-gray-800 rounded-lg overflow-hidden animate-pulse"
        >
          <div className="aspect-square bg-gray-800" />
          <div className="p-4 space-y-2">
            <div className="h-3 w-16 bg-gray-800 rounded" />
            <div className="h-4 w-24 bg-gray-800 rounded" />
            <div className="h-3 w-20 bg-gray-800 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default RosterSkeleton;
